<template>
    <div>
        <ImageTextWide :info="welcome"/>

        <div v-if="showWelcomeModal" class="welcome-overlay">
            <div class="welcome-modal">
                <button class="close-btn" @click="closeWelcomeModal">✕</button>
                <div class="welcome-content">
                    <div class="welcome-text" v-html="popup.text"></div>
                    <div class="welcome-image">
                        <img :src="popup.img" :alt="popup.title"/>
                    </div>
                </div>
            </div>
        </div>
        <h1>Aktuelle Informationen</h1>

        <div style="margin-bottom: 64px;">
            <InfoContainer v-for="info in infos" :info="info" v-bind:key="info.title"/> 
        </div>
        
        <h1 class="bilder">Bildergalerie</h1>
        <ImageSlider :images="images"/>

        <div style="text-align: center;margin-top: 48px;">
            <a href="https://www.dasgesundetier.de/?refID=1086085">
                <img src="https://www.dasgesundetier.de/gfx/partner/banner_sinnesplatz_728x90.png" alt="dasgesundetier.de">
            </a>
        </div>
    </div>
</template>

<script>
import InfoContainer from '../components/InfoContainer.vue'
import ImageTextWide from '../components/ImageTextWide.vue'
import ImageSlider from '../components/ImageSlider.vue'

export default {
  name: 'Homepage',
  data() {
    return {
        showWelcomeModal: false,
        popup: {
            title: 'Eurasierschau 2026',
            img: require("../assets/Medebach_Flyer.jpeg"),
            text: `<p>Denkt dran auch anzumelden, wir freuen uns auf euch! Mehr Informationen findet ihr <a href="https://www.der-eurasier.de/events/eurasierschau/" target="_blank" rel="noopener">hier</a>.</p>`
        },
        welcome: {
            title: "Herzlich Willkommen!",
            description: `<p>Wir heißen Sie herzlich Willkommen auf der Homepage unserer Zuchtstätte Eurasier vom Gonsbachtal.</p>
            <p>Schauen Sie sich um, entdecken und verlieben Sie sich in die wunderbare Hunderasse Eurasier - wie auch wir es getan 
            haben und lernen Sie uns und unsere Zuchtstätte kennen.</p>
            <p>Aktuelle Informationen und Fotos unserer Hunde und Zucht finden Sie auch immer auf unserer <a href="https://www.facebook.com/EurasierVomGonsbachtal/">
            Facebook Seite</a> und für noch schnellere Updates abonnieren sie doch unseren <a href=" https://whatsapp.com/channel/0029Vb4HCLe1SWsxuoKldW2g">
            Whatsappkanal</a>. Auch für Beratung und Informationen zu unseren Kooperationspartner zum Thema Hundeernährung stehen wir Ihnen gerne zur
            Verfügung.</p>`,
            img: require('../assets/img/Khali_Platz.jpg'),
            img_description: 'Khaleesi von den Wolfswiesen - Eine unserer Zuchthündinnen',
            contact_link: true
        },
        infos: [
            {
                title: "Planung: E-Wurf vom Gonsbachtal",
                date: "Stand: 19.08.2026",
                description: `<p>Mit unserer Hündin Arya befinden wir uns in der Planung zu unserem E-Wurf, welche vorraussichtlich Ende 2026/Anfang 2027 in die Endphase eintritt.
                    </p><p>Interessierte können sich gerne bei der <a href="https://www.der-eurasier.de/wurfmeldungen/">Welpenvermittlung</a> unseres Zuchtvereines melden oder auch gerne direkt mit uns Kontakt aufnehmen. Bei einem ungezwungenen
                persönlichen Treffen oder einem Spaziergang können Sie <a href="https://eurasiervomgonsbachtal.de/kontakt">uns</a> und unsere Zuchtstätte näher kennen lernen.</p>`
            },
            {
                title: "Eurasierschau 2026 in Medebach",
                date: "04.09 - 06.09.2026",
                description: `Am 04.09-06.09 findet die Eurasierschau in Medebach statt. Denkt dran auch anzumelden, wir freuen uns auf euch! Weitere Infos findet ihr <a href="https://www.der-eurasier.de/events/eurasierschau/" target="_blank" rel="noopener">hier</a>. Zuschauer sind natürlich auch willkommen.`,
                img: require("../assets/Medebach_Flyer.jpeg")
            },
        ],
        images: [
            {
                title: "Mora, Khaleesi und Arya zu Besuch bei Akito vom Gonsbachtal",
                img: require("../assets/img/Homepage/Gruppenfoto_Akito.jpg")
            },
            {
                title: "Fellpflege muss sein - Arya, Finja und Amon vom Gonsbachtal",
                img: require("../assets/img/Homepage/Welpen2.jpg")
            },
            {
                title: "Wir sind übrigens echte Meenzer - Bahghira vom Gonsbachtal an Fasnacht",
                img: require("../assets/img/Homepage/Fasnacht.jpg")
            },
            {
                title: "Widersehensfreude: Erstmal Spielen - Arya und Akito vom Gonsbachtal",
                img: require("../assets/img/Homepage/Akito_Arya.jpg")
            },
            {
                title: "Zeitsprung - aber gespielt wieder immer noch zusammen",
                img: require("../assets/img/Homepage/Spielen_groß.jpg")
            },
            {
                title: "Unser B-Wurf - einmal still halten fürs Foto bitte",
                img: require("../assets/img/Homepage/B-Wurf.jpg")
            },
            {
                title: "Arya vom Gonsbachtal beim Fotoshoot",
                img: require("../assets/img/Homepage/Arya_Model.jpg")
            },
            {
                title: "Khaleesi von den Wolfswiesen natürlich auch",
                img: require("../assets/img/Homepage/Khaleesi_model.jpg")
            },
            {
                title: "Auch im Urlaub mit dabei - Khaleesi von den Wolfswiesen",
                img: require("../assets/img/Homepage/Khali1.jpg")
            },
            {
                title: "Halbbrüder - Aktio und Baghira vom Gonsbachtal",
                img: require("../assets/img/Homepage/Familie.jpg")
            },
            {
                title: "Khaleesi von den Wolfswiesen - als Welpe",
                img: require("../assets/img/Homepage/Khali2.jpg")
            },
            {
                title: "Akito vom Gonsbachtal",
                img: require("../assets/img/Homepage/Akito_groß.jpg")
            },
            {
                title: "B-Winry vom Gonsbachtal",
                img: require("../assets/img/Homepage/Winry.jpg")
            },
            {
                title: "Als Welpe wird ganz viel gekuschelt",
                img: require("../assets/img/Homepage/Kuscheln.jpg")
            },
            {
                title: "Und auch mit Halbschwester Arya gespielt",
                img: require("../assets/img/Homepage/Spielen.jpg")
            },
            {
                title: "Nie vergessen - Camora von der Mainschleife",
                img: require("../assets/img/Homepage/Mora_Model.jpg")
            },
        ]
    }
  },
    mounted() {
        try {
            const seen = localStorage.getItem('homepageWelcomeSeen')
            if (!seen) {
                this.showWelcomeModal = true
            }
        } catch (e) {
            this.showWelcomeModal = true
        }
    },
    methods: {
        closeWelcomeModal() {
            try {
                localStorage.setItem('homepageWelcomeSeen', 'true')
            } catch (e) {}
            this.showWelcomeModal = false
        }
    },
  components: {
    InfoContainer,
    ImageTextWide,
    ImageSlider,
}
}
</script>

<style scoped>
:root {
  --backgroundColor: #dcdece;
  --mainText: #333D29;
  --mainTextLight: #70875A;
  --linkText: #936639;
  --focusedText: #582F0E;
  --higlightedText: #04A0A2;
}

.swiper {
    margin-bottom: 0px;
}

h1 {
    color: var(--higlightedText);
    margin-bottom: 8px;
}

h1.bilder {
    color: var(--mainText);
}

img {
    width: 100%;
    object-fit: contain;
}

/* Welcome modal styles */
.welcome-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}
.welcome-modal {
    background: white;
    border-radius: 8px;
    max-width: 90vw;
    max-height: 90vh;
    padding: 32px;
    box-shadow: 0 8px 24px rgba(0,0,0,0.2);
    position: relative;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.welcome-content {
    display: flex;
    flex-direction: column;
    gap: 24px;
    align-items: center;
    text-align: center;
    min-width: 0;
}
.welcome-image img {
    display: block;
    width: auto;
    max-width: 100%;
    max-height: 60vh;
    height: auto;
    border-radius: 6px;
    object-fit: contain;
}
.welcome-text {
    color: var(--mainText);
    font-size: 16px;
    line-height: 1.6;
}
.close-btn {
    position: absolute;
    top: 8px;
    right: 8px;
    background: transparent;
    border: none;
    font-size: 18px;
    cursor: pointer;
}

@media (min-width: 800px) {
    /* On wider screens keep modal compact and center content */
    .welcome-content { margin: 0 auto; }
}
</style>